/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Details_TitleInputs */

const en_us2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise details`)
};

const pt_br2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do exercício`)
};

const es_419_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del ejercicio`)
};

const pt_pt2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do exercício`)
};

const fr_fr2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l'exercice`)
};

const de_de2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungsdetails`)
};

const it_it2_exercise_details_title = /** @type {(inputs: Exercise_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise details" |
*
* @param {Exercise_Details_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_details_title = /** @type {((inputs?: Exercise_Details_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Details_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_details_title(inputs)
	if (locale === "es-419") return es_419_exercise_details_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_details_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_details_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_details_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_details_title(inputs)
	return en_us2_exercise_details_title(inputs)
});
export { exercise_details_title as "exercise.details_title" }